<div *ngIf="navData" class="data-wrap" fxLayout="column">
    <div class="title" fxLayoutAlign="start start" fxLayoutGap="5px">
        <mat-icon class="{{ navData.data.iconClass }}">{{ navData.data.icon }}</mat-icon>
        <div class="{{ navData.data.titleClass }}">{{ navData.data.title }}</div>
    </div>
    <div class="desc">{{ navData.data.contentBody }}</div>

    <div
        class="action"
        [fxLayout]="navData.data.cancelBtn ? 'row-reverse wrap' : 'row-reverse'"
        fxLayoutAlign="start center"
        [fxLayoutGap]="navData.data.cancelBtn ? '0px' : '10px'"
        [class.disableIt]="showGroupWork || showGroups"
    >
        <button
            fxFlex="0 0 auto"
            class="mobile-button positive"
            (click)="showGroupWork = true; action = 'done'"
            mat-raised-button
            i18n
        >
            Yes
        </button>

        <button
            fxFlex="0 0 auto"
            class="mobile-button custom"
            (click)="showGroupWork = true; action = 'continueLater'"
            mat-button
            i18n
        >
            Continue later
        </button>
        <button
            *ngIf="navData.data.cancelBtn"
            fxFlex="0 0 auto"
            class="mobile-button negative"
            (click)="action = 'cancel'; onClose.emit({ data: navData.data.cancelBtn.action })"
            mat-button
            i18n
        >
            {{ navData.data.cancelBtn.label }}
        </button>
        <button
            *ngIf="!navData.data.cancelBtn"
            fxFlex="0 0 auto"
            class="mobile-button negative"
            (click)="showGroupWork = false; action = 'cancel'; onClose.emit({ data: TakeResActionValue.CANCEL })"
            mat-button
            i18n
        >
            Close
        </button>
    </div>
    <div *ngIf="showGroupWork" class="mt-1" fxLayout="column" fxLayoutAlign="center end" fxLayoutGap="10px">
        <div class="desc" i18n>Did you take this {{ navData.data.resItemName }} by yourself or with a group?</div>
        <div
            [class.disableIt]="showGroups"
            class="action group-work-action"
            fxLayout="row-reverse"
            fxLayoutAlign="start center"
            fxLayoutGap="10px"
        >
            <button
                fxFlex="0 0 auto"
                class="mobile-button positive"
                (click)="
                    onClose.emit({
                        data: action === 'done' ? TakeResActionValue.CONTINUE : TakeResActionValue.CONTINUE_LATER
                    })
                "
                mat-raised-button
                i18n
            >
                By myself
            </button>
            <button fxFlex="0 0 auto" class="mobile-button negative" (click)="showGroups = true" mat-button i18n>
                With a group
            </button>
            <button
                fxFlex="0 0 auto"
                class="mobile-button negative"
                (click)="showGroupWork = false; (showGroups); action = null"
                mat-button
                i18n
            >
                Cancel
            </button>
        </div>
        <div class="w-100" *ngIf="showGroups" fxLayout="column" fxLayoutAlign="center end" fxLayoutGap="10px">
            <app-user-search-chips-display
                [user]="navData.data.user"
                (onUpdateSelectiedUsers)="participantUsers = $event"
            ></app-user-search-chips-display>
            <app-occasion-spend-time
                label="Time spent for this groupwork"
                i18n-label="@@spendTimeForThisGroupWork"
                [occasion]="navData.data.occasion"
                [formControl]="timeSpendControl"
            ></app-occasion-spend-time>
            <div class="action mt-1" fxLayout="row-reverse" fxLayoutAlign="start center" fxLayoutGap="10px">
                <button fxFlex="0 0 auto" class="mobile-button positive" (click)="submit()" mat-raised-button i18n>
                    Done
                </button>

                <button
                    fxFlex="0 0 auto"
                    class="mobile-button negative"
                    (click)="
                        onClose.emit({
                            data: action === 'done' ? TakeResActionValue.CONTINUE : TakeResActionValue.CONTINUE_LATER
                        })
                    "
                    mat-button
                    i18n
                >
                    Close
                </button>
                <button fxFlex="0 0 auto" class="mobile-button negative" (click)="showGroups = false" mat-button i18n>
                    Cancel
                </button>
            </div>
        </div>
    </div>
</div>
